// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XuPR","newExpiryDate":"styles_newExpiryDate__qEdtX","footer":"styles_footer__1KySH"};